import { useEffect, useState } from 'react'

export const MATCH_MEDIA_MOBILE = '(max-width: calc(768px - 1px))'
export const MATCH_MEDIA_TABLET = '(min-width: 768px) and (max-width: calc(1024px - 1px))'
export const MATCH_MEDIA_LARGE_DESKTOP = '(min-width: 1550px)'

export function getBreakpoints() {
  try {
    const isMobile = window.matchMedia(MATCH_MEDIA_MOBILE).matches
    const isTablet = window.matchMedia(MATCH_MEDIA_TABLET).matches
    const isLargeDesktop = window.matchMedia(MATCH_MEDIA_LARGE_DESKTOP).matches
    const isDesktop = !isMobile && !isTablet
    return {
      isMobile,
      isTablet,
      isDesktop,
      isLargeDesktop,
    }
  } catch (error) {
    return { isMobile: false, isTablet: false, isDesktop: true, isLargeDesktop: false }
  }
}

export function useBreakpoints() {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isLargeDesktop, setIsLargeDesktop] = useState(false)
  const isDesktop = !isMobile && !isTablet

  // mobile
  useEffect(() => {
    const matchMedia = window.matchMedia(MATCH_MEDIA_MOBILE)
    setIsMobile(matchMedia.matches)

    const handleResize = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches)
    }

    matchMedia.addEventListener('change', handleResize)

    return () => {
      matchMedia.removeEventListener('change', handleResize)
    }
  }, [])

  // tablet
  useEffect(() => {
    const matchMedia = window.matchMedia(MATCH_MEDIA_TABLET)
    setIsTablet(matchMedia.matches)

    const handleResize = (event: MediaQueryListEvent) => {
      setIsTablet(event.matches)
    }

    matchMedia.addEventListener('change', handleResize)

    return () => {
      matchMedia.removeEventListener('change', handleResize)
    }
  }, [])

  // large desktop
  useEffect(() => {
    const matchMedia = window.matchMedia(MATCH_MEDIA_LARGE_DESKTOP)
    setIsLargeDesktop(matchMedia.matches)

    const handleResize = (event: MediaQueryListEvent) => {
      setIsLargeDesktop(event.matches)
    }

    matchMedia.addEventListener('change', handleResize)

    return () => {
      matchMedia.removeEventListener('change', handleResize)
    }
  }, [])

  return { isMobile, isTablet, isDesktop, isLargeDesktop }
}
